import { addDays } from 'date-fns';

const initialState = () => ({
  isOpened: false,
  loading: false,
  error: null,
  productId: null,
  period: null,
  blankModel: {
    startDate: null,
    endDate: null
  },
  predefinedModel: {
    padTemplate: {},
    startDate: null,
    endDate: null // Esse campo é calculado a partir do startDate e period.
  }
});

const ACTION_KEY = 'PAD_CREATOR_MODEL_MODAL';

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_OPEN`: {
      const { productId } = action.payload;
      return {
        ...state,
        isOpened: true,
        productId
      };
    }
    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false,
        isRequestDone: true,
        error: action.payload
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      const padTemplate = action.payload;
      const { period } = padTemplate;

      return {
        ...state,
        isOpened: true,
        error: null,
        loading: false,
        period,
        predefinedModel: {
          ...state.predefinedModel,
          padTemplate
        }
      };
    }
    case `${ACTION_KEY}_CHANGE_BLANK_MODEL_DATE`: {
      const { startDate, endDate } = action.payload;
      const { startDate: cStartDate, endDate: cEndDate } = state.blankModel;
      const nStartDate = startDate ? startDate : cStartDate;
      const nEndDate = endDate ? endDate : cEndDate;

      return {
        ...state,
        isOpened: true,
        blankModel: {
          ...state.blankModel,
          startDate: nStartDate ? new Date(nStartDate).toISOString() : nStartDate,
          endDate: nEndDate ? new Date(nEndDate).toISOString() : nEndDate
        }
      };
    }
    case `${ACTION_KEY}_CHANGE_PREDEFINED_MODEL_DATE`: {
      let { startDate } = action.payload;
      const nStartDate = new Date(startDate).toISOString();
      const nEndDate = addDays(startDate, state.period).toISOString();

      return {
        ...state,
        isOpened: true,
        predefinedModel: {
          ...state.predefinedModel,
          startDate: nStartDate,
          endDate: nEndDate
        }
      };
    }
    case `${ACTION_KEY}_SUBMIT`: {
      return {
        ...state,
        isOpened: false,
        error: null,
        isRequestDone: true
      };
    }
    case `${ACTION_KEY}_RESET`: {
      return {
        ...state,
        blankModel: {
          startDate: null,
          endDate: null
        },
        predefinedModel: {
          padTemplate: {},
          startDate: null,
          endDate: null
        }
      };
    }
    default:
      return state;
  }
};

export default reducer;
